import About from "Pages/Common/About";
import ConsultingAndManagement from "Pages/Common/ConsultingAndManagement";
import Dashboard from "Pages/Common/Dashboard";
import Productions from "Pages/Common/Productions";
import CreateProject from "Pages/Common/Projects/Create";
import ListProjects from "Pages/Common/Projects/List";
import UpdateProject from "Pages/Common/Projects/Update";
import Register from "Pages/Common/Register";

const AuthRoutes = {
  Dashboard: {
    icon: "Home",
    name: "Home",
    path: "/home",
    element: Dashboard,
    noWrapper: true,
  },
  About: {
    icon: "Home",
    name: "Sobre nós",
    path: "/about",
    element: About,
    hasBgImg: true,
  },
  // Profile: {
  //   icon: "User",
  //   name: "Meu perfil",
  //   path: "/profile",
  //   element: Profile,
  // },
  Productions: {
    icon: "User",
    name: "Produções artísticas",
    path: "/productions",
    element: Productions,
    greenFigure: true,
  },
  CreateProject: {
    icon: "User",
    name: "Formulário para Envio do Projeto:",
    path: "/create-project",
    element: CreateProject,
  },
  ListProjects: {
    icon: "User",
    name: "Projetos Aportados",
    path: "/list-projects",
    element: ListProjects,
    noWrapper: true,
  },
  UpdateProject: {
    icon: "User",
    name: "Projetos Aportados",
    path: "/update-projects/:id",
    element: UpdateProject,
  },
  ConsultingAndManagement: {
    icon: "User",
    name: "",
    path: "/consulting-and-management",
    element: ConsultingAndManagement,
  },
  Register: {
    icon: "User",
    name: "",
    path: "/register",
    element: Register,
  },
};

export default AuthRoutes;
